import { useTranslation } from 'react-i18next';
import React, { useCallback, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';

import { IconRcMainLogoMobile } from 'assets/sidebar';
import { Button } from '@/components';
import { mobileConnect, shortenAddress } from 'utils';
import { useCurrentAddressInfo } from 'hooks';
import { isUserInstalledWallet, maybeWalletProviderFrom } from '@/utils/wallet';

import MobileModal from '../MobileModal';
import style from './index.module.css';

export default () => {
  const { t } = useTranslation();
  const [showAddr, setShowAddr] = useState(false);
  const { address } = useCurrentAddressInfo();
  const history = useHistory();
  const isInWalletApp = isUserInstalledWallet();

  const handleConnect = useCallback(() => {
    if (address) {
      history.replace(`/profile/${address}/`);
      return;
    }

    if (maybeWalletProviderFrom('coinbase-browser')) {
      mobileConnect(false);
    } else {
      mobileConnect(true);
    }
  }, [address, history]);

  return (
    <div className={style.head}>
      <NavLink to={'/'}>
        <IconRcMainLogoMobile className={style.mainLogo} />
      </NavLink>
      {isInWalletApp && (
        <Button onClick={handleConnect} className={style.connectBtn} type="primary">
          {address ? shortenAddress(address) : t('MobileHeader.connect-wallet')}
        </Button>
      )}
      {showAddr && <MobileModalAddrInfo setShow={setShowAddr} />}
    </div>
  );
};

const MobileModalAddrInfo = React.memo((props: { setShow: Function }) => {
  const { t } = useTranslation();

  const { address } = useCurrentAddressInfo();
  if (!address) return null;

  return (
    <MobileModal setIsShow={props.setShow} diyStyle={{ padding: '30px' }}>
      <div className={style.addr}>
        <div className={style.title}>{t('MobileHeader.9n4c71')}</div>
        <div>{address}</div>
      </div>
    </MobileModal>
  );
});
